import {DmsRequest} from '../common/dms-request';
import {FunctionalHeader} from '../common/functional-header';
import {TechnicalHeaderInRequest} from '../common/technical-header-in-request';
import {UserInformation} from '../common/user-information';
import {GetCustomerRequestBody} from './get-customer-request-body';

export class GetCustomerRequest implements DmsRequest {
  readonly simpleName = 'get-customer';
  technicalHeader: TechnicalHeaderInRequest;
  functionalHeader: FunctionalHeader;
  userInformation: UserInformation;
  body: GetCustomerRequestBody;
}
